import Vue from 'vue'

Vue.filter('formatTime', function (time) {
    if(time){
        let d = new Date(time)
        let year = d.getFullYear()
        let month = d.getMonth() + 1
        let day = d.getDate()
        let hour = d.getHours()
        let minutes = d.getMinutes()
        return `${addZero(year)}-${addZero(month)}-${addZero(day)} ${addZero(hour)}:${addZero(minutes)}`
    }else{
        return ''
    }
});

function addZero(value) {
    if(value<10) {
        return "0" + value
    }else {
        return value
    }
}

Vue.filter('sex', function (sex) {
    if(sex == 0){
        return "男"
    }else if(sex == 1) {
        return "女"
    }else {
        return "不详"
    }
});

Vue.filter('jsonString', function (data) {
    if(data){
        return JSON.parse(data).join(",")
    }else{
        return ''
    }
});


// WEBPACK FOOTER //
// ./src/utils/filter.js